import React from 'react';
import { BaseButton } from '../../BaseButton/BaseButton';
import ButtonGroup, { ButtonGroupProps } from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

type TValue = number | string;
type TLabel = string | React.ElementType;

export type PMenuTabs = Pick<ButtonGroupProps, 'orientation' | 'className'> & {
  onChange: (value: TValue) => void;
  value: TValue;
  tabs: Array<{ value: TValue; label: TLabel; isActive?: boolean }>;
};

const useStyles = makeStyles(() => ({
  root_horizontal: {},
  root_vertical: {
    width: '100%',
    boxShadow: '0 8px 30px rgba(108, 108, 108, 0.15)',
  },
  btn_horizontal: {
    boxShadow: '0 8px 30px rgba(108, 108, 108, 0.15)',
    maxHeight: '40px',
    border: 0,
    fontWeight: 500,
    '&:first-child': {
      borderRadius: '10px 0px 0px 10px',
    },
    '&:last-child': {
      borderRadius: '0px 10px 10px 0px',
    },
    '&:not(:last-child)': {
      marginRight: '5px',
    },
  },
  btn_vertical: {
    width: '100%',
    height: '40px',
    border: 0,
    fontWeight: 500,
    '&:first-child': {
      borderRadius: '10px 10px 0px 0px',
    },
    '&:last-child': {
      borderRadius: '0 0 10px 10px',
    },
  },
  primary: {
    background: '#7AC5F1',
    color: 'white',
    '&:hover': {
      opacity: 0.8,
      background: '#7AC5F1',
    },
  },
}));

export const MenuTabs: React.FC<PMenuTabs> = (props) => {
  const {
    onChange,
    value,
    tabs,
    orientation = 'horizontal',
    className,
    ...otherProps
  } = props;
  const classes = useStyles({ orientation });
  return (
    <ButtonGroup
      orientation={orientation}
      {...otherProps}
      className={clsx(
        orientation === 'horizontal'
          ? classes.root_horizontal
          : classes.root_vertical,
        className,
      )}
    >
      {tabs.map((btn: any) => {
        const btnVariant =
          btn.isActive || value === btn.value ? 'contained' : 'outlined';
        return (
          <BaseButton
            className={clsx(
              orientation === 'horizontal'
                ? classes.btn_horizontal
                : classes.btn_vertical,
              btnVariant === 'contained' && classes.primary,
            )}
            key={btn.value}
            variant={btnVariant}
            onClick={() => onChange(btn.value)}
          >
            {btn.label}
          </BaseButton>
        );
      })}
    </ButtonGroup>
  );
};
